import React from "react";
import {
  Button,
  message,
} from "antd";
import cssStyle from "./head.module.css";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
import { Col, Row, Card, Typography, Image, Tag, Slider, Steps } from "antd";
import { getHashColor } from "../../plugins/colorTag";
import moment from "moment";
import {Clipboard} from 'ts-clipboard';
import "moment/locale/zh-cn";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import {
  fetchOneTrack,
  TrackModel,
} from "../../api/track";
import { fetchOneStage, fetchStages, StageModel } from "../../api/stage";
moment.locale("zh-cn");
const { Step } = Steps;

const { Title, Text } = Typography;
interface IPropCard {
  title: string;
  imageUrl: string;
  description: string;
  tags: string[];
  team: number;
  prize: string;
  startDate: number;
  endDate: number;
  midDate: Record<string, number>;
  track: TrackModel;
  stages: Record<number, StageModel>;
  stageEndTime: number;
}

export const headCard: React.FunctionComponent<IPropCard> = (
  prop: IPropCard
) => {
  const {
    title,
    imageUrl,
    description,
    tags,
    team,
    prize,
    startDate,
    endDate,
    midDate,
    track,
    stages,
    stageEndTime,
  } = prop;
  console.log("stageEnddate",stageEndTime-Date.now());
  const nowDate = Math.min(Math.max(Date.now(), startDate), endDate);
  const stdDate = (time: number) =>
    Math.round(time/86400000)*86400000;
  const getPerc = (time: number) =>
    Math.round(((stdDate(time) - stdDate(startDate)) / (stdDate(endDate) - stdDate(startDate))) * 100);
  /*const marks: Record<number, string> = {
    0: `${moment(startDate).format("MM月DD日")}`,
    100: `${moment(endDate).format("MM月DD日")}`,
  };*/
  const perc = getPerc(nowDate);
  type stagetimeline = {name:string,starttime:number,endtime:number,link:string}
  const stagetimelinelist : stagetimeline[] = [];
  type nametime = {name:string,time:number}
  const nametimelist : nametime[] = [];

  /*for (const cate in midDate) {
    nametimelist.push({name:cate,time:midDate[cate]});
    if (marks[getPerc(midDate[cate])])
      marks[getPerc(midDate[cate])] += `\n${cate.replace("_","")}`;
    else
      marks[getPerc(midDate[cate])] = `${moment(midDate[cate]).format("MM月DD日")}\n${cate.replace("_","")}`;
    
  }
  nametimelist.sort(($a: nametime, $b: nametime): number => {
    if ($a.name.split("_")[0].localeCompare($b.name.split("_")[0]))
      return $a.name.localeCompare($b.name);
    return $a.time - $b.time;
  });*/
  const stagelist : StageModel[] = [];
  var submitcount = 0;
  var userCount = track.userCount;
  var teamCount = track.teamCount;;
  for (const st in stages)
  {
    stagelist.push(stages[st]);
    submitcount += stages[st].judgecount;
  }
  for (var tag of tags)
  {
    if (tag.split(":")[0]=="提交次数+")
      submitcount += Number(tag.split(":")[1]);
  }
  const setshare = () => {
    Clipboard.copy(`https://naic.pcl.ac.cn/contest/${track.competition}/${track.id}`);
    message.success("分享链接已复制到剪切板");
  }
  //console.log("stage:",stagelist);
  /*for (var i = 0; i < nametimelist.length; i += 2)
  {
    stagetimelinelist.push({
      name:stagelist[Math.round(i/2)].title,
      starttime:stagelist[Math.round(i/2)].starttime,
      endtime:nametimelist[i+1].time,
      link:`/contest/${track.competition}/${track.id}/${stagelist[Math.round(i/2)].id > track.nowStage ? track.nowStage : stagelist[Math.round(i/2)].id}`,
    });
  }*/
  //console.log(stagetimelinelist);
  //console.log(tags);
  const Tags =
    tags?.map((tag) => (
      (tag.split(":")[0]=="tag")?
      (
      <Tag
        className={cssStyle.headTags}
        color={getHashColor(tag)}
        key={`${tag}-card-head`}
      >
        {tag.split(":")[1]}
      </Tag>
      )
      :(null)
    )) || [];
    const Orgs =
      tags?.map((tag) => (
        (tag.split(":")[0]=="主办单位"||tag.split(":")[0]=="承办单位")?
        (
          <Row style={{margin:"4px"}}>
            <Text type="secondary" style={{ fontSize: 14, height: 20, margin: 0 }}>
                  {t(tag.split(":")[0]) + "："}
            </Text>
            <Text style={{ fontSize: 14, height: 20, margin: 0 }}>
                  {tag.split(":")[1]}
            </Text>
          </Row>
        )
        :(null)
      )) || [];
    const Award = +prize > 0 ? ("￥"+prize):(tags?.map((tag) => (
      tag.split(":")[0]=="比赛奖励"?
      (
        tag.split(":")[1]
      )
      :(null)
    )) || []);
    const Day2end = Math.floor(((stageEndTime-Date.now())/1000)/86400);
    const Hour2end = Math.floor(((stageEndTime-Date.now())/1000)%86400/3600);
    const Min2end = Math.floor(((stageEndTime-Date.now())/1000)%3600/60);
    //console.log("Award",Award);
  return (
    <Card bordered={true} className={cssStyle.titleCard}>
      <Row>
        <Col span={6} style={{margin:"auto"}}>
          <Image src={imageUrl} preview={false} max-height="240px" width="100%"/>
        </Col>
        <Col span={17} offset={1}>
          <Title level={3}>{title} <Button onClick={ setshare }style={{ marginLeft: "50px" }}>{t("分享")}</Button></Title>
          <Title level={5}>{t("距离本阶段结束还有")}: {Date.now()<stageEndTime?Day2end.toString()+t("天")+Hour2end.toString()+t("小时")+Min2end.toString()+t("分钟"):t("本赛段已结束")}</Title>
          <Text type="secondary" style={{ marginBottom: "15px" }}>
            {description}
          </Text>
          <Row style={{margin:"8px 0"}}>
            <Col span={14} >
              <Row style={{margin:"0 0 10px"}}>
                {Tags}
              </Row>
                {Orgs}
            </Col>
            <Col span={10} style={{margin:"18px 0 0"}}>
            <Row style={{margin:"0 0 10px"}}>
                <Title level={5}>{t("实时报名人数")}：{userCount}</Title>
              </Row>
              <Row style={{margin:"0 0 10px"}}>
                <Title level={5}>{t("实时报名团队")}：{teamCount}</Title>
              </Row>
              <Row style={{margin:"0 0 10px"}}>
              <Title level={4}>{t("提交次数")}：{submitcount}</Title>
              </Row>
              <Row style={{margin:"0 0 10px"}}>
              <Title level={4}>{t("比赛奖励")}：{Award}</Title>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}  style={{ padding: "8px 8% 0px" }}>
          <Steps current={stagelist.length+1} onChange={(currect)=>{window.location.href = `/contest/${track.competition}/${track.id}/${stagelist[currect].id>track.nowStage?track.nowStage:stagelist[currect].id}`}}>
            {stagelist.map((timenode)=>
              (
                //<Link to={`/${track.competition}/${track.id}/${timenode.id>track.nowStage?track.nowStage:timenode.id}`}>
                <Step
                  title={`${timenode.title}`} 
                  description={`${timenode.configStartTime>4070880000?t("待定"):moment(timenode.configStartTime*1000).format("MM.DD")===moment(timenode.configEndTime*1000).format("MM.DD")?moment(timenode.configEndTime*1000).format("MM.DD"):moment(timenode.configStartTime*1000).format("MM.DD")+"~"+moment(timenode.configEndTime*1000).format("MM.DD")}`}
                  //status={`${Date.now()<timenode.configStartTime*1000?"wait":Date.now()<timenode.configEndTime*1000?"process":"finish"}`}
                  status={`${timenode.id==72||timenode.id==73?"process":Date.now()<timenode.configStartTime*1000?"wait":Date.now()<timenode.configEndTime*1000?"process":"finish"}`}
                  disabled={timenode.id>track.nowStage?true:false}
                />
                //</Link>
              ))
            }
          </Steps>
        </Col>
      </Row>
    </Card>
  );
};

export default headCard;
